
export const pages = ["HOME", "WHY THE CLOUD", "WHAT WE DO", "FAQ", "CONTACT US"];